import React from 'react';
import clsx from 'clsx';

import { BaseComponentProps } from '@utils/types/baseComponents';
import WysiwygText from '@components/_shared/wysiwygText';

import styles from './styles.module.scss';

type Props = {
  title: string;
  order: number;
  description?: string | { text?: any };
} & BaseComponentProps;

const TitleAndDescriptionWithOrder = (props: Props) => {
  const { title, description, order, containerStyle } = props;
  return (
    <div className={clsx([styles.titleAndDescription, containerStyle])}>
      <div className={styles.title}>
        <div className={styles.title__order}>
          {order < 10 ? `0${order}` : order}
        </div>
        {title}
      </div>

      {typeof description === 'string' && (
        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}

      {typeof description === 'object' && (
        <WysiwygText
          content={description}
          containerStyle={styles.description}
        />
      )}
    </div>
  );
};

export default TitleAndDescriptionWithOrder;
